module.exports = __webpack_public_path__ + "static/media/registration.b8494f8d.svg";